import React from 'react';
import { Grid, Typography } from '@mui/material';
import { toCurrency } from '../../utils/currency/currency.utils';
import { CurrencyCode } from '../../utils/currency/currency.constants';
import { COLORS_COOLGRAY60, COLORS_GREEN, COLORS_LIGHTGRAY } from '../../App.constants';
import { BenchmarkBoxLoader } from './BenchmarkBoxLoader';

interface IProps {
  backgroundColor: string;
  bottom: number;
  header: string;
  isHighlighted?: boolean;
  mid: number;
  showValue?: boolean;
  top: number;
}

export const BenchmarkBox: React.FC<IProps> = (props) => {
  return (
    <Grid
      item={true}
      xs={2}
      bgcolor={props.backgroundColor}
      border={props.isHighlighted ? `1px solid ${COLORS_GREEN}` : '1px solid transparent'}
      alignItems={'center'}
    >
      <Typography
        marginY={2}
        height={'50px'}
        textAlign={'center'}
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'center'}
        letterSpacing={7}
        fontSize={'0.98rem'}
        color={COLORS_COOLGRAY60}
      >
        {props.header.split(' ')[0]}
        <br />
        {props.header.split(' ')[1]}
      </Typography>
      {props.showValue && (
        <React.Fragment>
          <Typography
            textAlign={'center'}
            marginY={1.5}
          >
            {toCurrency(props.top, {
              currencyCode: CurrencyCode.USD,
              fractionDigits: 0,
            })}
          </Typography>
          <Typography
            textAlign={'center'}
            paddingY={1.5}
            borderTop={`1px solid ${COLORS_LIGHTGRAY}`}
            borderBottom={`1px solid ${COLORS_LIGHTGRAY}`}
          >
            {toCurrency(props.mid, {
              currencyCode: CurrencyCode.USD,
              fractionDigits: 0,
            })}
          </Typography>
          <Typography
            textAlign={'center'}
            marginY={1.5}
          >
            {props.bottom}
          </Typography>
        </React.Fragment>
      )}
      {!props.showValue && <BenchmarkBoxLoader />}
    </Grid>
  );
};

BenchmarkBox.displayName = 'Benchmarks';
